// ABOUTME: Relation view filtered to show only active relations.
// ABOUTME: Displays a data grid with active relation data and export/create actions.
import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../components/theme/text/Text";
import { tokens } from "../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { useTranslation } from "react-i18next";
import { WarehouseRelationsCard } from "../../../../components/global/cards/warehouserelations/WarehouseRelationsCard";
import MpAddRelation from "../../../../components/global/ModalsProgression/MpAddRelation/MpAddRelation";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import ShDoubleTextSkeleton from "../../../../components/theme/skeleton/ShDoubleTextSkeleton";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShLabel from "../../../../components/theme/label/ShLabel";
import { getRelationStateLabelData } from "../../../../utils/labelColorText";
import { useExportRelationsMutation, useGetRelationsQuery } from "../../../../newapi/global/relation/relationSlice";
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../utils/permissions';
import { useSelector } from "react-redux";
import { RELATION_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import { general_states } from "../../../../utils/staticEnums";

const SpRelationDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <ButtonGroup version={2}>
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                onClick={props.exportRelations}
                isLoading={props.isExporting}
                endIcon={<DownloadOutlinedIcon/>}
                variant="contained"
            >
                {t("export")}
            </Shbutton>
            {props.hasCreatePermission && (
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_relation')}
            </Shbutton>
            )}
        </ButtonGroup>
    );
}

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [RELATION_FILTER_KEYS.CUSTOM_CUTOFF],
};

const Active = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [config, setConfig] = useState({state: general_states.ACTIVE});

    const hasCreatePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RELATION_MANAGE])
    );

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };


    const [exportRelations, {isLoading: isExporting}] = useExportRelationsMutation();
    const handleExportRelations = async () => {
        try {
            if(isExporting) return;

            exportRelations().unwrap()
            .then(res => {
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer');
                if (newWindow) {
                    setTimeout(() => {
                        window.URL.revokeObjectURL(res.data);
                    }, 500);
                } else {
                    window.URL.revokeObjectURL(res.data);
                }
            })
            .catch(e => {
                console.error(e);
            });
            // Download is handled automatically in the mutation
        } catch (error) {
            console.error("Export failed", error);
        }
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
                mobileActions:<GridActions
                isExporting={isExporting}
                handleOpen={() => setAddModalOpen(true)}
                exportRelations={handleExportRelations}
                hasCreatePermission={hasCreatePermission}
            />
            // apiRef: props.apiRef
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[handleExportRelations,hasCreatePermission,isExporting]);

    const [relationId, setRelationId] = useState();
    const relationIdRef = useRef(relationId);

    const getRelationDetails = (params) => {
        if (!params) return;

        const newrelationId = parseInt(params.row.id);
        window.location.href = `/warehouse/relations/data?relation=${newrelationId}`;
    };

    const columns = [
        {
            field: "name",
            headerName: t("relation"),
            flex:2,
            cellClassName: "relation",
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Text semibold>{cellValues.row.name}</Text>
                )
            }
        },
        {
            field: "street",
            headerName: t("address"),
            flex:1,
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShDoubleTextSkeleton/>
                }

                const street = cellValues.row.street ? cellValues.row.street : "";
                const house = cellValues.row.house_nr ? cellValues.row.house_nr : "";
                const extra = cellValues.row.house_nr_extra ? cellValues.row.house_nr_extra : "";
                const postal = cellValues.row.postal ? cellValues.row.postal : "";
                const city = cellValues.row.city ? cellValues.row.city : "";

                return <Text>{street} {house}{extra}<br/> {postal}, {city}</Text>
            },
        },
        {
            field: "phone",
            headerName: t("phone"),
            flex:1,
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return cellValues.row.phone
            },
        },
        {
            field: "email",
            headerName: t("email"),
            flex:1,
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return cellValues.row.email
            },
        },
        {
            field: "website",
            headerName: t("website"),
            flex:1,
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return cellValues.row.website
            },
        },
        {
            field: "cutoffTime",
            headerName: t("custom_cutoff"),
            flex:1,
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return cellValues.row.cutoffTime
            },
        },
        {
            field: "warehouseZone",
            sortable:false,
            headerName: t("warehouse_zone"),
            flex:1,
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return cellValues.row.warehouseZone?.description ?? ""
            },
        },
        {
            field: "webshopcount",
            headerName: t("channels"),
            flex:1,
            sortable:false,
            renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (cellValues.row.webshopCredentials ? cellValues.row.webshopCredentials?.length : 0)
            },
        },
        {
            field: "createdAt",
            headerName: t("date_created"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <span>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </span>
                );
              }
        },
        {
            field: "state",
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext } = getRelationStateLabelData(params.row.state, theme);

                return (
                    <ShLabel palette="normal" size={32}  variant={labelcolor}>
                        {t(labeltext)}
                    </ShLabel>
                );
              }
        },
        {
            field: "phoneView",
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <WarehouseRelationsCard
                        onClick={() => getRelationDetails(cellValues)}
                        skeleton={cellValues.row.skeleton}
                        {...cellValues.row}
                    />
                );
                // console.log(cellValues.row);
               // return (
                    // <AllCarriersCard {...cellValues.row} />
               // )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >

            <ShDataGrid2 key={theme.palette.mode}
                content={useGetRelationsQuery}
                config={config}
                gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} isExporting={isExporting} exportRelations={handleExportRelations} hasCreatePermission={hasCreatePermission}></GridActions>}
                title={t("overview")}
                gridOptions={gridOptions}
                columns={columns}
                sortModel={{field: columns[0].field,type:"ASC"}}

                onRowClick={getRelationDetails}
                >
            </ShDataGrid2>



            <MpAddRelation onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />
        </Box>
    )
};

export default Active;
